import { sleep } from '@last/core'

import type { CashMachineOptions, ICashMachine } from './types'

class DevCashMachine implements ICashMachine {
  private inputAmountListener: (amount: number) => void = () => {}
  private totalAmountListener: (amount: number) => void = () => {}
  private cancelled = false

  async init({
    inputAmountListener,
    totalAmountListener
  }: Pick<CashMachineOptions, 'inputAmountListener' | 'totalAmountListener'>) {
    this.inputAmountListener = inputAmountListener
    this.totalAmountListener = totalAmountListener
  }

  async charge(amount: number) {
    await sleep(1000)
    let inputAmount = 0
    while (inputAmount < amount && !this.cancelled) {
      inputAmount += Math.min(500, amount - inputAmount)
      this.inputAmountListener(inputAmount)
      await sleep(1000)
    }
    if (this.cancelled) {
      this.inputAmountListener(0)
      this.cancelled = false
      await sleep(3000)
      return 0
    } else {
      return amount
    }
  }

  async payIn(amount: number) {
    return this.charge(amount)
  }

  async payOut(amount: number) {
    await sleep(1000)
    return amount
  }

  async cancel() {
    this.cancelled = true
  }

  async refreshTotalAmount() {
    await sleep(1000)
    this.totalAmountListener(Math.round(Math.random() * 1000))
  }
}

export default new DevCashMachine()
